module.exports = __webpack_public_path__ + "img/logo_nknylab.3b7f8d81.jpg";